<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
        :title="prefix + title">
        <ConsultarContratos :objeto="objeto" :prefix="prefix + title" />
    </b-modal>
</template>

<script>
import ConsultarContratos from "@/modules/contratos/ConsultarContratos.vue"

export default {
    components: {
        ConsultarContratos,
    },
    props: {
        objeto: {
            type: String,
            default: null
        },
        almoxarifado: {
            type: Number,
            default: null,
        },
        id: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Contratos ",
        },
        prefix: {
            type: String,
            default: "",
        },
        departamento: {
            type: Object,
            default: undefined,
        },
        tipoOperacao: {
            type: String,
            default: "consulta",
        },
    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.modalAberto = false
            this.$emit("close")
        },

    },
}
</script>
